import { render, staticRenderFns } from "./delete-realestate.vue?vue&type=template&id=6fa55ac4&"
import script from "./delete-realestate.vue?vue&type=script&lang=js&"
export * from "./delete-realestate.vue?vue&type=script&lang=js&"
import style0 from "./delete-realestate.vue?vue&type=style&index=0&id=6fa55ac4&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports